import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import JournalViewer from '../../../../DaEditorWrapper/Viewer/Journal';
import TextRenderer from '../../../../TextRenderer';
import { MatureDeviationContext } from '../../../../Context/MatureDeviationContext';
const TextContent = ({ textContent, className, deviationId, disableStylesForLegacy })=>{
    const { t } = useTranslation();
    const { showBlocked } = useContext(MatureDeviationContext);
    return showBlocked ? /*#__PURE__*/ React.createElement("div", {
        className: className
    }, t('deviation.details.hiddenContent')) : /*#__PURE__*/ React.createElement(TextRenderer, {
        className: className,
        textContent: textContent,
        reactViewer: JournalViewer,
        viewerKey: deviationId,
        legacyTheme: "journal",
        disableStylesForLegacy: disableStylesForLegacy
    });
};
TextContent.displayName = 'TextContent';
export default TextContent;

//# sourceMappingURL=TextContent.js.map